import { Airport } from '../airport';
import { DATA } from '../data';
import { IMAGES } from './images';
import { REWARD } from '../rewardedManager';
import { UpgradeData } from '../data.type';
import { niceRounding } from '../helpers';
import { PRICE_STEP_COEFFICIENT, UPGRADE_PRICE_COEFFICIENT } from './baseData';

export type AirplaneUpgradeType = 'ticket_price' | 'capacity' | 'speed';

export type AirplaneColor = 'blue' | 'red' | 'green' | 'yellow' | 'purple';

const DEFAULT_AIRPLANES = 2;
const AIRPLANE_LIMIT = 30;

export const AVERAGE_AIRPLANE_SPEED = 300; // for the competition airplanes

export const AIRPLANE_DATA = {
  MAX_AIRPLANES: AIRPLANE_LIMIT,
  DEFAULT_AIRPLANES,
  priceFn: (ownedAirplanes: number) => niceRounding(5000 * Math.pow(2, ownedAirplanes)),
  tripLengthMs: (airport1: Airport, airport2: Airport, airplaneSpeed: number) => {
    const distance = airport1.distanceTo(airport2);
    return Math.round((distance / airplaneSpeed) * 25000);
  },
};

export const AIRPLANE_UPGRADES: {
  [k in AirplaneUpgradeType]: UpgradeData;
} = {
  // from 4 to 100, 2 increment
  capacity: {
    icon: IMAGES.ICONS.persons,
    description: 'Seats',
    maxValue: 48,
    priceFn: (upgradeLevel, priceStep) =>
      niceRounding(100 * Math.pow(UPGRADE_PRICE_COEFFICIENT, upgradeLevel) * Math.pow(PRICE_STEP_COEFFICIENT, priceStep)),
    valueFn: (upgradeLevel) => Math.round(4 + upgradeLevel * 2),
    readableValue: (upgradeLevel) => `${AIRPLANE_UPGRADES.capacity.valueFn(upgradeLevel)}`,
  },
  // from 10 => 100, 2$ increment
  ticket_price: {
    icon: IMAGES.ICONS.ticket,
    description: 'Minimum ticket price, the real price will be calculated based on the distance',
    maxValue: 45,
    priceFn: (upgradeLevel, priceStep) =>
      niceRounding(100 * Math.pow(UPGRADE_PRICE_COEFFICIENT, upgradeLevel) * Math.pow(PRICE_STEP_COEFFICIENT, priceStep)),
    valueFn: (upgradeLevel) => {
      let ticketPrice = (10 + 2 * upgradeLevel) * DATA.currentAdvanceData.multiplier;
      if (REWARD.reward === 'price') {
        ticketPrice *= 2;
      }
      return Math.round(ticketPrice);
    },
    readableValue: (upgradeLevel) => `$${AIRPLANE_UPGRADES.ticket_price.valueFn(upgradeLevel)}`,
  },
  // from 100 to 500, 10 increment
  speed: {
    icon: IMAGES.ICONS.speed,
    maxValue: 40,
    description: 'Speed',
    priceFn: (upgradeLevel, priceStep) =>
      niceRounding(100 * Math.pow(UPGRADE_PRICE_COEFFICIENT, upgradeLevel) * Math.pow(PRICE_STEP_COEFFICIENT, priceStep)),
    valueFn: (upgradeLevel) => {
      let speed = 100 + 10 * upgradeLevel;
      if (REWARD.reward === 'speed') {
        speed *= 2;
      }
      return Math.round(speed);
    },
    readableValue: (upgradeLevel) => `${AIRPLANE_UPGRADES.speed.valueFn(upgradeLevel)}`,
  },
};
